{
  "R": [
    0, 13, 21, 26, 27, 25, 22, 21, 22, 28, 39, 54, 75, 98, 124, 148, 171, 189,
    202, 210, 213, 211, 206, 200, 195, 193, 195, 201, 211, 225, 240, 255
  ],
  "G": [
    0, 5, 11, 20, 31, 44, 58, 72, 86, 99, 109, 116, 120, 122, 122, 122, 121,
    121, 124, 129, 137, 147, 161, 175, 190, 205, 218, 229, 238, 245, 251, 255
  ],
  "B": [
    0, 14, 30, 46, 61, 71, 77, 78, 75, 68, 60, 52, 48, 47, 53, 65, 83, 105, 131,
    157, 183, 205, 222, 235, 241, 243, 242, 240, 239, 240, 245, 255
  ],
  "A": [
    0, 4, 8, 12, 17, 21, 25, 29, 33, 37, 41, 45, 50, 54, 58, 62, 66, 70, 74, 78,
    83, 87, 91, 95, 99, 103, 107, 111, 116, 120, 124, 128
  ],
  "I": [
    0, 8, 16, 25, 33, 41, 49, 58, 66, 74, 82, 90, 99, 107, 115, 123, 132, 140,
    148, 156, 165, 173, 181, 189, 197, 206, 214, 222, 230, 239, 247, 255
  ]
}
